/**
 * Shared className for the Figma-spec "secondary pill" button — a white
 * h-11 button with a soft gray border and a subtle hover lift. Used for
 * the "View completed" and "Manage AI Agents" buttons in the action
 * center header (and any new secondary header actions).
 *
 * Extracted to avoid silent drift between the two long classNames.
 */
export const secondaryPillButtonClass =
  'inline-flex items-center gap-1.5 h-11 bg-white border border-neutral-300 rounded-lg px-3 text-sm font-medium text-neutral-800 tracking-[-0.2px] whitespace-nowrap transition-all hover:bg-neutral-100 hover:text-neutral-900 hover:shadow-sm hover:border-neutral-400'

/**
 * DS2026 "primary pill" — the bright-green primary action button, sibling of
 * `secondaryPillButtonClass`. Bright basil green (`brand-bright`) with a darker
 * `brand-active` hover, matching the primary buttons on the homepage, campaigns
 * and sequencing surfaces.
 */
export const primaryPillButtonClass =
  'inline-flex items-center gap-1.5 h-11 bg-brand-bright text-white rounded-lg px-3 text-sm font-medium tracking-[-0.2px] whitespace-nowrap transition-all hover:bg-brand-active hover:shadow-sm disabled:bg-neutral-100 disabled:text-neutral-400'

/**
 * Hover-state half of `secondaryPillButtonClass`, for components that already
 * provide their own base shape (e.g. `FbDropdown`'s built-in trigger styles)
 * but want the same secondary-pill hover lift. Used by header dropdowns that
 * sit next to "View completed" / "Manage AI Agents" buttons so the controls
 * react identically on hover.
 */
export const secondaryPillHoverClass =
  'transition-all hover:bg-neutral-100 hover:text-neutral-900 hover:shadow-sm hover:border-neutral-400'
